import R from 'ramda';

export const getProductDetails = ({ content, productSwatch }) => {
  // Show the ingredients for the selected variant
  const selectedSku = R.prop('selectedSKU', productSwatch);
  const selectedSwatch = R.compose(
    R.find(({ sku }) => sku === selectedSku),
    R.pathOr([], ['productSwatch', 'swatches']),
  )(content);

  const tabs = [
    ...R.path(['productDetails', 'tabs'], content),
    {
      title: R.path(['productDetails', 'ingredientsTitle'], content),
      content: R.propOr('', 'ingredients', selectedSwatch),
    },
  ];

  return {
    ...R.prop('productDetails', content),
    tabs,
  };
};
